<template>
  <div class="home" :starting="starting">
    <Background :pump="null" :time="'day'"></Background>
    <Background id="bg_night" :pump="null" :time="'night'"></Background>
    <div class="bluebar"></div>
    <h1>SCADA Superhero!</h1>
    <h2>Take on the challenge of looking after the water supply for Water Town</h2>
    <div class="challenge-container left-padding" ref="scroll" :size="size">
      <div class="challenge" v-for="(chl,chlidx) in challenges" :key="chl.number" v-show="!chl.hidden" :last="chlidx==challenges.length-1" :number="chl.number">
        <div :class="['lock', isLocked(chl.number) ? 'locked' : 'unlocked']"><span>{{chl.number}}</span><img class="locked-icon" v-if="isLocked(chl.number)" @click="$refs.unlock.showContactForm(chl.number,true)" src="@/assets/img/icon_lock.svg"><img v-if="!isLocked(chl.number)" src="@/assets/img/icon_unlock_black.svg"></div>
        <div class="challenge-title">Challenge <span>{{chl.number}}</span></div>
        <div class="challenge-length"><span>Length</span> {{chl.length}} mins</div>
        <div :class="['challenge-level', chl.level]">
          <div class="challenge-tab">{{chl.level}}</div>
          <div class="flex-separator"></div>
          <div v-if="hasScore(chl.number)" class="challenge-topscore">Your Top Score</div>
          <div v-if="hasScore(chl.number)" class="challenge-score">{{$store.state.scores[chl.number]}}</div>
          <div v-if="!hasScore(chl.number)" class="challenge-topscore no-score">Not Played</div>
        </div>
        <div class="challenge-desc" v-html="chl.desc"></div>
        <div class="challenge-buttons" v-if="!isLocked(chl.number)"><button @click="startChallenge(chl.number == 1 ? 0 : chl.number)" class="action-button">Start Challenge</button></div>
        <div class="challenge-buttons" v-if="isLocked(chl.number)"><button @click="$refs.unlock.showContactForm(chl.number,true)" class="action-button action-disabled">Unlock</button></div>
      </div>
      <div class="right-space">&nbsp;</div>
    </div>
    <div class="left-margin right-margin white-separator"></div>
    <div class="share-container">
      <button @click="share=true" class="action-button">Share Game</button>
    </div>
    <div class="scroll-down hide-standalone">
      Scroll down to learn more about GE Digital's HMI/SCADA and analytics capabilities
      <br>
      <a @click="scrollDown()" ><img src="@/assets/img/arrow-down-small.svg" width="14" height="16"></a>
    </div>
    <div>
    </div>
    <Unlock @unlockchallenge="unlockChallenge($event)" ref="unlock"></Unlock>
    <Share :active="share" v-if="share" @hide="share=false"></Share>
  </div>
</template>

<script>

import challenges from '@/assets/json/challenges.json'
import Share from '@/components/Share.vue'
import Unlock from '@/components/Unlock.vue'
import Background from '@/components/Background.vue'

export default {
  name: 'home',
  data: function () {
    return {
      last: 0,
      form: false,
      share: false,
      loaded: false,
      unlock: '',
      challenges: challenges,
      starting: false,
      size: 0
    }
  },
  components: {
    Share,
    Unlock,
    Background
  },
  mounted: function () {
    if (this.$store.state.lastDate > 0) {
      this.last = (new Date() - new Date(this.$store.state.lastDate * 1)) / 1000
    }
    if (window.Munchkin) {
      window.Munchkin.init('330-FCH-291')
      window.Munchkin.createTrackingCookie(true)
    }
    const scrollDiv = this.$refs.scroll
    const self = this
    scrollDiv.addEventListener('mousedown', function (ev) {
      scrollDiv.scrolling = true
      scrollDiv.ox = ev.clientX
      scrollDiv.oy = ev.clientY
      scrollDiv.style.cursor = 'ew-resize'
    })
    scrollDiv.addEventListener('mousemove', function (ev) {
      if (scrollDiv.scrolling && scrollDiv.scrollBy) {
        scrollDiv.scrollBy(-ev.movementX, 0)
      }
    })
    scrollDiv.addEventListener('mouseup', function (ev) {
      scrollDiv.ox = null
      scrollDiv.oy = null
      scrollDiv.scrolling = false
      scrollDiv.style.cursor = 'default'
    })
    const resizeEv = function (ev) {
      const container = document.querySelector('.challenge-container')
      if (!container) {
        return
      }
      const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
      const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
      self.size = 0
      if (vw < 1800) {
        self.size = 1
      }
      if (vh < 900) {
        self.size = 1
      }
      if (vw < 1600) {
        self.size = 2
      }
      if (vh < 800) {
        self.size = 2
      }
      if (vw < 1400) {
        self.size = 3
      }
      if (vh < 750) {
        self.size = 3
      }
      if (vw < 1280) {
        self.size = 4
      }
      if (vh < 700) {
        self.size = 4
      }
      self.$nextTick(function () {
        const chlg = document.querySelector('.challenge[number="1"]')
        const st = window.getComputedStyle(chlg)
        const width = (parseFloat(st.width)) * 3 + (parseFloat(st.marginRight) * 2)
        const minPadding = 5 / 100
        const containerw = Math.round(width + vw * minPadding)
        if (vw > containerw) {
          container.setAttribute('full', 1)
        } else {
          container.setAttribute('full', 0)
        }
      })
    }
    window.addEventListener('resize', resizeEv)
    resizeEv()
  },
  methods: {
    startChallenge: function (num) {
      this.starting = true
      const self = this
      setTimeout(function () {
        self.$router.push('/challenge/' + num + '/messages')
      }, 500)
    },
    unlockChallenge: function (number) {
      this.$forceUpdate()
    },
    hasScore: function (ch) {
      return !this.isLocked(ch) && this.$store.state.scores[ch] > 0
    },
    isLocked: function (ch) {
      return this.$store.state.locks[ch]
    },
    scrollDown: function () {
      parent.postMessage('scrolldown')
    }
  },
  computed: {
  }
}
</script>

<style scoped lang="scss" >
.home{
  background-size: cover;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
#bg_night{
  opacity: 0;
  transition: opacity linear .5s;
}
.flex-separator{
  flex: 1 0;
}
h1{
  padding-top: 2vh;
  font-size: 52px;
  font-weight: normal !important;
  z-index: 1;
}
h2{
  z-index: 1;
  font-size: 22px;
  padding: 20px 0 50px 0;
  color: #8F9297;
  font-weight: normal !important;
}
.background{
  z-index: 0;
}
.background::after{
  content: ' ';
  width: 100%;
  height: 100%;
  background-image:linear-gradient(180deg, rgba(255,255,255,0.5), rgba(255,255,255,0));
  display: block;
  position:absolute;
}
.white-separator, .share-container{
  z-index: 1;
}
.challenge-container{
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 2vw;
  margin-bottom: 0;
  scrollbar-color: transparent transparent;
  scrollbar-width: thin;
  &::-webkit-scrollbar{
    background-color: transparent;
    border-radius: 5px 5px;
    height: 3px;
  }
  &::-webkit-scrollbar-track{
    background-color: transparent;
    border-radius: 3px 3px;
  }
  &::-webkit-scrollbar-thumb{
    background-color: transparent;
    border-radius: 3px 3px;
  }
  .challenge{
    user-select: none;
    flex: 1 0 66vh;
    width: 66vh;
    max-height: 500px;
    height: 50vh;
    max-width: 536px;
    background-color: rgba(255,255,255,0.9);
    margin-right: 30px;
    border-radius: 10px 0 10px 10px;
    position: relative;
    text-align: left;
    padding: 40px 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    > div {
      padding-right: 40px;
      padding-left: 40px;
    }
    .lock{
      position: absolute;
      top: 0;
      right: 0;
      width: 122px;
      height: 122px;
      background-image: url(../assets/img/lock-blue.svg);
      background-position: top right;
      background-size: contain;
      .locked-icon{
        cursor: pointer;
      }
      span{
        z-index: 1;
        pointer-events: none;
      }
    }
    .lock img{
      position: absolute;
      right: 23px;
      top: 17px;
      width: 28px;
    }
    .lock > span{
      position: absolute;
      top: 32px;
      right: 32px;
      font-weight: bold;
      color: #00B5E2;
    }
    .lock.unlocked{
      background-image: url(../assets/img/lock-gray.svg);
      > span{
        color: #fff;
        top: 38px;
      }
    }
    .lock.locked{
      .span{
        cursor:pointer;
      }
    }
  }
  .challenge-title{
    margin-top: 5vw;
    font-size:42px;
    span{
      font-weight: bold;
      font-style: italic;
    }
  }
  .challenge-length{
    background-image: url(../assets/img/Icon_Time.svg);
    background-repeat: no-repeat;
    background-position: -6px -1px;
    line-height: 26px;
    padding-left: 24px !important;
    margin-left: 40px;
    span{
      font-weight: bold;
      text-transform: uppercase;
    }
  }
  .challenge-level{
    display: flex;
    display: -webkit-box;
    justify-content: space-between;
    border-bottom: 2px solid #00A849;
    margin: 20px 0;
    height: 50px;
    > div{
      line-height: 50px;
      height: 50px;
    }
    .challenge-tab{
      margin: 0;
      margin-right: 20px;
      padding: 0 20px;
      background-color: #00A849;
      color: #fff;
      border-radius:5px 5px 0 0;
      box-sizing: border-box;
      text-transform: uppercase;
      font-weight: bold;
    }
    .challenge-topscore{
      text-transform: uppercase;
      padding-right: 20px;
      &.no-score{
        color: #ACACAC;
      }
    }
    .challenge-score{
      background-image: url(../assets/img/Trophy.svg);
      background-repeat: no-repeat;
      background-position: 0 13px;
      background-size: 20px 20px;
      padding-left: 30px;
      font-weight: bold;
      font-size: 24px;
    }
    &.Intermediate{
      border-bottom: 2px solid #FFCC01;
      .challenge-tab{
        background-color: #FFCC01;
      }
    }
    &.Hard{
      border-bottom: 2px solid #F45050;
      .challenge-tab{
        background-color: #F45050;
      }
    }
  }
  .challenge-desc{
    color: #8F9297;
    padding-bottom: 20px;
    font-size: 18px;
    min-height: 4em;
  }
  &[full='1']{
    padding-left: 0;
    padding-right: 0;
    justify-content:center;
    margin-left: auto;
    margin-right: auto;
    .challenge:nth-child(4){
      margin-right: 0;
    }
    .right-space{
      display:none;
    }
  }
}
.home{
  .challenge-container{
    transition: margin-top ease-in-out 1s, opacity linear .5s;
  }
  &[starting=true]{
    .challenge-container{
      margin-top: 50vh;
      opacity: 0;
    }
    #bg_night{
      opacity: 1;
    }
  }
}
@media (max-height: 880px){
}
@media (max-height: 700px){
  #ge_game h1{
    font-size: 36px;
  }
  #ge_game h2{
    padding: 8px 20px 20px 20px;
  }
  .bluebar{
    height: 20px;
  }
  .white-separator{
    margin-bottom: 1vh;
  }
}
@media (max-height: 660px){
  h1{
    font-size: 32px !important;
  }
  h2{
    font-size: 18px !important;
    padding: 8px !important;
  }
}
.challenge-container[size='1'] {
  .challenge{
    width: 480px;
    max-width: 480px !important;
    flex: 1 0 480px;
    height: 400px;
    max-height: 400px;
    padding: 30px 0;
    > div{
      padding-right: 30px;
      padding-left: 30px;
    }
  }
  .challenge-length{
    margin-right: 30px;
    margin-left: 30px !important;
  }
  .challenge-title{
    font-size: 34px;
  }
  .challenge-level{
    font-size: 16px;
    height: 40px;
    margin: 14px 0;
    .challenge-topscore{
      font-size: 13px;
    }
    .challenge-score{
      font-size: 20px;
    }
    > div {
      height: 40px;
      line-height: 40px;
    }
  }
    .action-button{
    font-size: 16px;
    height: 40px;
    line-height: 40px;
    padding: 0 32px;
  }
}
.challenge-container[size='2'] {
  .challenge{
    width: 410px;
    max-width: 410px !important;
    flex: 1 0 410px;
    height: 350px;
    max-height: 350px;
    padding: 24px 0;
    > div{
      padding-right: 24px;
      padding-left: 24px;
    }
  }
  .challenge-title{
    font-size: 32px;
  }
  .challenge-desc{
    font-size: 16px;
  }
  .challenge-length{
    margin-right: 24px;
    margin-left: 24px !important;
  }
  .challenge-level{
    font-size: 16px;
    height: 40px;
    margin: 14px 0;
    .challenge-topscore{
      font-size: 13px;
    }
    .challenge-score{
      font-size: 20px;
      background-size: 16px 16px;
    }
    > div {
      height: 40px;
      line-height: 40px;
    }
  }
    .action-button{
    font-size: 16px;
    height: 40px;
    line-height: 40px;
    padding: 0 32px;
  }
}
.challenge-container[size='3'] {
  .challenge{
    width: 370px;
    max-width: 370px !important;
    flex: 1 0 370px;
    height: 300px;
    max-height: 300px;
    .lock{
      width: 98px;
      height: 98px;
      img{
        width: 20px;
        top: 14px;
        right: 18px;
      }
      span{
        top: 26px;
        right: 25px;
        font-size: 11px;
      }
      &.unlocked{
        span{
          top: 30px;
          right: 25px;
        }
      }
    }
    padding: 24px 0;
    > div{
      padding-right: 24px;
      padding-left: 24px;
    }
  }
  .challenge-length{
    margin-right: 24px;
    margin-left: 24px !important;
  }
  .challenge-title{
    font-size: 24px;
  }
  .challenge-desc{
    font-size: 14px;
  }
  .challenge-level{
    font-size: 12px;
    height: 36px;
    margin: 12px 0;
    .challenge-score{
      font-size: 20px;
      background-size: 14px 14px;
    }
    > div {
      height: 36px;
      line-height: 36px;
      font-size: 10px;
    }
  }
  .action-button{
    font-size: 14px;
    height: 36px;
    line-height: 36px;
    padding: 0 28px;
  }
}
.challenge-container[size='4'] {
  .challenge{
    width: 340px;
    max-width: 340px !important;
    flex: 1 0 340px;
    height: 280px;
    max-height: 280px;
    .lock{
      width: 98px;
      height: 98px;
      img{
        width: 20px;
        top: 14px;
        right: 18px;
      }
      span{
        top: 26px;
        right: 25px;
        font-size: 11px;
      }
      &.unlocked{
        span{
          top: 30px;
          right: 25px;
        }
      }
    }
    padding: 24px 0;
    > div{
      padding-right: 24px;
      padding-left: 24px;
    }
  }
  .challenge-length{
    margin-right: 24px;
    margin-left: 24px !important;
  }
  .challenge-level{
    .challenge-tab{
      margin-right: 12px;
      padding: 0 16px;
    }
    .challenge-topscore{
      font-size: 10px;
      padding-right: 12px;
    }
    .challenge-score{
      font-size: 18px;
      background-size: 14px 14px;
    }
  }
  .challenge-title{
    font-size: 24px;
  }
  .challenge-desc{
    font-size: 12px;
  }
  .challenge-level{
    font-size: 12px;
    height: 36px;
    margin: 12px 0;
    .challenge-score{
      font-size: 20px;
    }
    > div {
      height: 36px;
      line-height: 36px;
    }
  }
  .action-button{
    font-size: 14px;
    height: 36px;
    line-height: 36px;
    padding: 0 28px;
  }
}
</style>
